"use strict";

IREP.ready(function () {
    var timeline = new TimelineMax({ paused: true });
    timeline/*.to('#quizBox .quit', 0.2, { display: "block", opacity: 1 })*/
            .fromTo('#quizBox .quit', .15, { rotationX: -120, opacity: 0, display: "none" }, { rotationX: 0, opacity: 1, transformOrigin: "50% 0%", transformPerspective: 200, display: "block", immediateRender: true })

    $('#quizBox').find('.open, .close').click(function () {
        $(this).hide();
        $(this).siblings($(this).hasClass('open') ? '.close' : '.open').show();
    });

    $('#quizBox').find('.open').click(function () {
        timeline.play();
    });

    $('#quizBox').find('.close').click(function () {
        timeline.reverse();
    });
});